package ai.wagemix.net.client

import ai.wagemix.net.models.WMReevaluateJD
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.contentTypeJson

class WMJobDescriptionReevaluateRequestBuilder: WMEventStreamReferencingRequestBuilder<
    WMJobDescriptionReevaluateRequestBuilder,
    WMReevaluateJD
>() {

    override fun build(): FSRequest<WMReevaluateJD> {
        method(FSRequest.Method.Post)
        contentTypeJson()
        replacePathParams(listOf("api", "v1", "reevaluate-jd"))
        return super.build()
    }

    override fun self(): WMJobDescriptionReevaluateRequestBuilder = this
}